import React, { useEffect, useState } from "react";
import profile from "../../Assets/Images/undraw_profile.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import axiosHttp from "../../Config";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import { roleType } from "../../Constants";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import ToggleSwitch from "../../Components/ToggleSwitch";

const Users = () => {
  const [usersList, setUsersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [entries, setEntries] = useState(10);
  const [key, setKey] = useState("");
  const [userCount, setUserCount] = useState(0);
  const [search, setSearch] = useState("");
  const [newUserCount, setNewUserCount] = useState(0);
  const [totalUserCount, setTotalUserCount] = useState(0);
  const [frequentUserCount, setFrequentUserCount] = useState(0);
  const [nonFrequentUserCount, setNonFrequentUserCount] = useState(0);
  const [premiumUserCount, setPremiumUserCount] = useState(0);
  const [basicUserCount, setBasicUserCount] = useState(0);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const searchValue = e.target.value;
    setSearch(searchValue);
  };

  useEffect(() => {
    // Fetch counts for all user types on mount
    fetchTabUserCounts();
    fetchAccountTypeCounts();
    fetchAllUserCounts();
    fetchNewUsersCount();
    const fetchDashboardStats = async () => {
      try {
        const res = await axiosHttp.get("admin-dashboard");
        if (res.status === 200) {
          setTotalUserCount(res.data.data.no_of_users);
        }
      } catch (error) {
        setTotalUserCount(0);
      }
    };
    fetchDashboardStats();
  }, []);

  useEffect(() => {
    if (search === "") {
      fetchUsersList(pageData.currentPage, entries, key);
    }
  }, [pageData.currentPage, entries, key, search]);

  useEffect(() => {
    if (search !== "") {
      const getSearchData = setTimeout(searchUser, 500);
      return () => clearTimeout(getSearchData);
    }
  }, [pageData.currentPage, entries, search, key]);

  useEffect(() => {
    // Update userCount when tab changes
    fetchTabUserCounts();
    fetchAccountTypeCounts();
  }, [key]);

  const fetchUsersList = async (current, count, key) => {
    setLoading(true);
    try {
      let url = `users?page=${current}&per_page=${count}`;
      if (key !== "") {
        url = `${url}&filter=${key}`;
      }
      const getUserList = await axiosHttp.get(url);
      if (getUserList.status === 200) {
        let data = getUserList.data.data;
        // Filter for new users if key is 'new'
        if (key === 'new') {
          const now = new Date();
          const currentMonth = now.getMonth();
          const currentYear = now.getFullYear();
          data = data.filter(user => {
            if (!user.created_at) return false;
            const createdAt = new Date(user.created_at);
            return (
              createdAt.getMonth() === currentMonth &&
              createdAt.getFullYear() === currentYear
            );
          });
        }
        let page = getUserList.data.meta;
        setPageData({
          currentPage: page.currentPage,
          totalPages: page.lastPage,
        });
        setUsersList(data);
        fetchUserCount(key);
      }
    } catch (error) {
      console.log(error);
      setUsersList([]);
      setUserCount(0);
      setPageData({
        currentPage: 1,
        totalPages: 1,
      });
      setLoading(false);
    }
  };

  const searchUser = async () => {
    try {
      const getSearchList = await axiosHttp.get(
        key !== ""
          ? `users?page=${pageData.currentPage}&per_page=${entries}&name=${search}&filter=${key}`
          : `users?page=${pageData.currentPage}&per_page=${entries}&name=${search}`
      );
      if (getSearchList.status === 200) {
        let data = getSearchList.data.data;
        let page = getSearchList.data.meta;
        setPageData({
          currentPage: page.currentPage,
          totalPages: page.lastPage,
        });
        setUsersList(data);
        searchedUserCount(search);
      }
    } catch (error) {
      console.log(error);
      setUsersList([]);
      setPageData({
        currentPage: 1,
        totalPages: 1,
      });
      toast.error(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const deleteHandler = async (id) => {
    setLoading(true);
    try {
      const deleteUser = await axiosHttp.delete(`users/${id}/delete`);
      if (deleteUser.status === 200) {
        setLoading(true);
        toast.success(deleteUser.data.message);
        if (key !== "") {
          fetchUsersList(pageData.currentPage, entries, key);
        } else {
          fetchUsersList(pageData.currentPage, entries);
        }
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    setPageData({ ...pageData, currentPage: event.selected + 1 });
  };

  const fetchUserCount = async (key) => {
    try {
      let url = '';
      if (key === 'new') {
        url = `user-count`;
      } else if (key === 'premium') {
        url = `user-count?account_type=premium`;
      } else if (key === 'basic') {
        url = `user-count?account_type=basic`;
      } else if (key !== "") {
        url = `user-count?filter=${key}`;
      } else {
        url = `user-count`;
      }
      const getUserCount = await axiosHttp.get(url);
      if (getUserCount.status === 200) {
        let data = getUserCount.data.data;
        setUserCount(data.count);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setUserCount(0);
      setLoading(false);
    }
  };

  const searchedUserCount = async (key) => {
    try {
      const getSearchUserCount = await axiosHttp.get(`user-count?name=${key}`);
      if (getSearchUserCount.status === 200) {
        let data = getSearchUserCount.data.data.count;
        setUserCount(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setUserCount(0);
      setLoading(false);
    }
  };

  const updateEntries = (e) => {
    let entryNumber = Number(e.target.value);
    setEntries(entryNumber);
  };

  const toggleSwitchHandler = async (id, active) => {
    const payload = {
      status: active,
    };
    try {
      const toggleStatus = await axiosHttp.post(`users/${id}/block`, {
        ...payload,
      });
      if (toggleStatus.status === 200) {
        toast.success(toggleStatus.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTabUserCounts = async () => {
    try {
      const frequentRes = await axiosHttp.get('users?page=1&per_page=1&filter=frequent');
      const frequentTotal = Number(frequentRes?.data?.meta?.total ?? 0);
      setFrequentUserCount(frequentTotal);
      const nonFrequentRes = await axiosHttp.get('users?page=1&per_page=1&filter=no-frequent');
      const nonFrequentTotal = Number(nonFrequentRes?.data?.meta?.total ?? 0);
      setNonFrequentUserCount(nonFrequentTotal);
    } catch (error) {
      setFrequentUserCount(0);
      setNonFrequentUserCount(0);
    }
  };

  const fetchNewUsersCount = async () => {
    try {
      const response = await axiosHttp.get('users?page=1&per_page=1&filter=new');
      const total = Number(response?.data?.meta?.total ?? 0);
      setNewUserCount(total);
    } catch (error) {
      setNewUserCount(0);
    }
  };

  const fetchAccountTypeCounts = async () => {
    try {
      const premiumRes = await axiosHttp.get('users?page=1&per_page=1&filter=premium');
      const premiumTotal = Number(premiumRes?.data?.meta?.total ?? 0);
      setPremiumUserCount(premiumTotal);
      const basicRes = await axiosHttp.get('users?page=1&per_page=1&filter=basic');
      const basicTotal = Number(basicRes?.data?.meta?.total ?? 0);
      setBasicUserCount(basicTotal);
    } catch (error) {
      setPremiumUserCount(0);
      setBasicUserCount(0);
    }
  };

  const fetchAllUserCounts = async () => {
    try {
      // Frequent Users
      const frequentRes = await axiosHttp.get('users?page=1&per_page=1&filter=frequent');
      setFrequentUserCount(frequentRes.status === 200 ? frequentRes.data.meta.total : 0);
      // Not Frequent Users
      const nonFrequentRes = await axiosHttp.get('users?page=1&per_page=1&filter=no-frequent');
      setNonFrequentUserCount(nonFrequentRes.status === 200 ? nonFrequentRes.data.meta.total : 0);
    } catch (error) {
      setFrequentUserCount(0);
      setNonFrequentUserCount(0);
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="container-fluid top-container">
      <div className="card  card-one-1 mb-5">
        <div className="card-body">
          <h4 className="title mb-5">User Details</h4>
          <div className="row">
            <div className="col-md-5">
              <h5 className="head">Users List</h5>
            </div>
            <div className="col-md-7 text-right"></div>
          </div>
          <div className="row mb-4">
            <div className="col-md-3 mb-3">
              <div className="pink-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-3 ml-2 mb-4 mt-4">
                      <div className="text-center icon-card">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.8678 16.8164L13.9995 16.8164L14.2942 16.8174C16.5466 16.8322 21.6938 17.0598 21.6938 20.5485C21.6938 24.0144 16.726 24.2404 14.3293 24.2552L13.4413 24.2552C11.1889 24.2403 6.04062 24.0131 6.04062 20.5287C6.04062 17.0585 11.1889 16.8321 13.4413 16.8174L13.736 16.8164C13.7818 16.8164 13.8257 16.8164 13.8678 16.8164ZM13.8678 18.5664C11.0958 18.5664 7.79062 18.907 7.79062 20.5287C7.79062 22.1137 10.8985 22.4842 13.6144 22.5052L13.8678 22.5062C16.6398 22.5062 19.9438 22.1667 19.9438 20.5485C19.9438 18.9105 16.6398 18.5664 13.8678 18.5664ZM23.147 16.3429C25.9738 16.7664 26.5677 18.0941 26.5677 19.1336C26.5677 19.7683 26.318 20.9268 24.6497 21.5626C24.547 21.6011 24.442 21.6198 24.3382 21.6198C23.9858 21.6198 23.6533 21.4051 23.5203 21.0563C23.3477 20.6048 23.5752 20.0984 24.0267 19.9269C24.8177 19.6259 24.8177 19.2934 24.8177 19.1336C24.8177 18.6226 24.1678 18.2656 22.8868 18.0743C22.4097 18.0019 22.0795 17.5574 22.1507 17.0779C22.2218 16.5996 22.6652 16.2811 23.147 16.3429ZM5.58375 17.0779C5.65492 17.5574 5.32475 18.0019 4.84758 18.0743C3.56658 18.2656 2.91675 18.6226 2.91675 19.1336C2.91675 19.2934 2.91675 19.6248 3.70892 19.9269C4.16042 20.0984 4.38792 20.6048 4.21525 21.0563C4.08225 21.4051 3.74975 21.6198 3.39741 21.6198C3.29358 21.6198 3.18858 21.6011 3.08591 21.5626C1.41641 20.9256 1.16675 19.7671 1.16675 19.1336C1.16675 18.0953 1.76058 16.7664 4.58858 16.3429C5.07042 16.2823 5.51142 16.5996 5.58375 17.0779ZM13.8678 4.66669C16.8078 4.66669 19.1983 7.05835 19.1983 9.99719C19.1983 12.936 16.8078 15.3277 13.8678 15.3277H13.8363C12.4129 15.323 11.0794 14.7654 10.0808 13.7574C9.07978 12.7505 8.53262 11.4135 8.5384 9.99369C8.5384 7.05835 10.9289 4.66669 13.8678 4.66669ZM13.8678 6.41669C11.8938 6.41669 10.2884 8.02319 10.2884 9.99719C10.2849 10.9539 10.6513 11.8487 11.3221 12.5242C11.993 13.1997 12.8866 13.5742 13.8386 13.5777L13.8678 14.4527V13.5777C15.8418 13.5777 17.4483 11.9724 17.4483 9.99719C17.4483 8.02319 15.8418 6.41669 13.8678 6.41669ZM21.0883 5.80944C23.1393 6.1466 24.6291 7.90127 24.6291 9.98144C24.6245 12.0756 23.06 13.8723 20.9891 14.1628C20.9483 14.1686 20.9075 14.1709 20.8678 14.1709C20.4385 14.1709 20.064 13.8548 20.0021 13.4173C19.9356 12.9378 20.2681 12.4956 20.7476 12.4291C21.961 12.2588 22.8768 11.2064 22.8791 9.9791C22.8791 8.76227 22.0065 7.73327 20.8036 7.5361C20.3276 7.45794 20.0045 7.0076 20.0826 6.53044C20.162 6.05327 20.6088 5.7336 21.0883 5.80944ZM7.65295 6.53044C7.73112 7.0076 7.40795 7.45794 6.93195 7.5361C5.72912 7.73327 4.85645 8.76227 4.85645 9.98144C4.85878 11.2064 5.77462 12.2599 6.98678 12.4291C7.46628 12.4956 7.79878 12.9378 7.73228 13.4173C7.67045 13.8548 7.29595 14.1709 6.86662 14.1709C6.82695 14.1709 6.78612 14.1686 6.74528 14.1628C4.67445 13.8723 3.11112 12.0756 3.10645 9.98377C3.10645 7.90127 4.59628 6.1466 6.64728 5.80944C7.13845 5.73244 7.57362 6.0556 7.65295 6.53044Z"
                            fill="#313131"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="col-md-6"></div>
                  </div>
                  <p className="text-center user-count">{totalUserCount}</p>
                  <p className="text-center user-text">No.of Users</p>
                </div>
              </div>
            </div>
            {/* New Users Card */}
            <div className="col-md-3 mb-3">
              <div className="yellow-card">
                <div className="card-body orange-card">
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-3 ml-2 mb-4 mt-4">
                      <div className="text-center icon-card">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.8678 16.8164L13.9995 16.8164L14.2942 16.8174C16.5466 16.8322 21.6938 17.0598 21.6938 20.5485C21.6938 24.0144 16.726 24.2404 14.3293 24.2552L13.4413 24.2552C11.1889 24.2403 6.04062 24.0131 6.04062 20.5287C6.04062 17.0585 11.1889 16.8321 13.4413 16.8174L13.736 16.8164C13.7818 16.8164 13.8257 16.8164 13.8678 16.8164ZM13.8678 18.5664C11.0958 18.5664 7.79062 18.907 7.79062 20.5287C7.79062 22.1137 10.8985 22.4842 13.6144 22.5052L13.8678 22.5062C16.6398 22.5062 19.9438 22.1667 19.9438 20.5485C19.9438 18.9105 16.6398 18.5664 13.8678 18.5664ZM23.147 16.3429C25.9738 16.7664 26.5677 18.0941 26.5677 19.1336C26.5677 19.7683 26.318 20.9268 24.6497 21.5626C24.547 21.6011 24.442 21.6198 24.3382 21.6198C23.9858 21.6198 23.6533 21.4051 23.5203 21.0563C23.3477 20.6048 23.5752 20.0984 24.0267 19.9269C24.8177 19.6259 24.8177 19.2934 24.8177 19.1336C24.8177 18.6226 24.1678 18.2656 22.8868 18.0743C22.4097 18.0019 22.0795 17.5574 22.1507 17.0779C22.2218 16.5996 22.6652 16.2811 23.147 16.3429ZM5.58375 17.0779C5.65492 17.5574 5.32475 18.0019 4.84758 18.0743C3.56658 18.2656 2.91675 18.6226 2.91675 19.1336C2.91675 19.2934 2.91675 19.6248 3.70892 19.9269C4.16042 20.0984 4.38792 20.6048 4.21525 21.0563C4.08225 21.4051 3.74975 21.6198 3.39741 21.6198C3.29358 21.6198 3.18858 21.6011 3.08591 21.5626C1.41641 20.9256 1.16675 19.7671 1.16675 19.1336C1.16675 18.0953 1.76058 16.7664 4.58858 16.3429C5.07042 16.2823 5.51142 16.5996 5.58375 17.0779ZM13.8678 4.66669C16.8078 4.66669 19.1983 7.05835 19.1983 9.99719C19.1983 12.936 16.8078 15.3277 13.8678 15.3277H13.8363C12.4129 15.323 11.0794 14.7654 10.0808 13.7574C9.07978 12.7505 8.53262 11.4135 8.5384 9.99369C8.5384 7.05835 10.9289 4.66669 13.8678 4.66669ZM13.8678 6.41669C11.8938 6.41669 10.2884 8.02319 10.2884 9.99719C10.2849 10.9539 10.6513 11.8487 11.3221 12.5242C11.993 13.1997 12.8866 13.5742 13.8386 13.5777L13.8678 14.4527V13.5777C15.8418 13.5777 17.4483 11.9724 17.4483 9.99719C17.4483 8.02319 15.8418 6.41669 13.8678 6.41669ZM21.0883 5.80944C23.1393 6.1466 24.6291 7.90127 24.6291 9.98144C24.6245 12.0756 23.06 13.8723 20.9891 14.1628C20.9483 14.1686 20.9075 14.1709 20.8678 14.1709C20.4385 14.1709 20.064 13.8548 20.0021 13.4173C19.9356 12.9378 20.2681 12.4956 20.7476 12.4291C21.961 12.2588 22.8768 11.2064 22.8791 9.9791C22.8791 8.76227 22.0065 7.73327 20.8036 7.5361C20.3276 7.45794 20.0045 7.0076 20.0826 6.53044C20.162 6.05327 20.6088 5.7336 21.0883 5.80944ZM7.65295 6.53044C7.73112 7.0076 7.40795 7.45794 6.93195 7.5361C5.72912 7.73327 4.85645 8.76227 4.85645 9.98144C4.85878 11.2064 5.77462 12.2599 6.98678 12.4291C7.46628 12.4956 7.79878 12.9378 7.73228 13.4173C7.67045 13.8548 7.29595 14.1709 6.86662 14.1709C6.82695 14.1709 6.78612 14.1686 6.74528 14.1628C4.67445 13.8723 3.11112 12.0756 3.10645 9.98377C3.10645 7.90127 4.59628 6.1466 6.64728 5.80944C7.13845 5.73244 7.57362 6.0556 7.65295 6.53044Z"
                            fill="#313131"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="col-md-6"></div>
                  </div>
                  <p className="text-center user-count">{newUserCount}</p>
                  <p className="text-center user-text">New Users</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="light-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-3 ml-2 mb-4 mt-4">
                      <div className="text-center light-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M13.8678 16.8164L13.9995 16.8164L14.2942 16.8174C16.5466 16.8322 21.6938 17.0598 21.6938 20.5485C21.6938 24.0144 16.726 24.2404 14.3293 24.2552L13.4413 24.2552C11.1889 24.2403 6.04062 24.0131 6.04062 20.5287C6.04062 17.0585 11.1889 16.8321 13.4413 16.8174L13.736 16.8164C13.7818 16.8164 13.8257 16.8164 13.8678 16.8164ZM13.8678 18.5664C11.0958 18.5664 7.79062 18.907 7.79062 20.5287C7.79062 22.1137 10.8985 22.4842 13.6144 22.5052L13.8678 22.5062C16.6398 22.5062 19.9438 22.1667 19.9438 20.5485C19.9438 18.9105 16.6398 18.5664 13.8678 18.5664ZM23.147 16.3429C25.9738 16.7664 26.5677 18.0941 26.5677 19.1336C26.5677 19.7683 26.318 20.9268 24.6497 21.5626C24.547 21.6011 24.442 21.6198 24.3382 21.6198C23.9858 21.6198 23.6533 21.4051 23.5203 21.0563C23.3477 20.6048 23.5752 20.0984 24.0267 19.9269C24.8177 19.6259 24.8177 19.2934 24.8177 19.1336C24.8177 18.6226 24.1678 18.2656 22.8868 18.0743C22.4097 18.0019 22.0795 17.5574 22.1507 17.0779C22.2218 16.5996 22.6652 16.2811 23.147 16.3429ZM5.58375 17.0779C5.65492 17.5574 5.32475 18.0019 4.84758 18.0743C3.56658 18.2656 2.91675 18.6226 2.91675 19.1336C2.91675 19.2934 2.91675 19.6248 3.70892 19.9269C4.16042 20.0984 4.38792 20.6048 4.21525 21.0563C4.08225 21.4051 3.74975 21.6198 3.39741 21.6198C3.29358 21.6198 3.18858 21.6011 3.08591 21.5626C1.41641 20.9256 1.16675 19.7671 1.16675 19.1336C1.16675 18.0953 1.76058 16.7664 4.58858 16.3429C5.07042 16.2823 5.51142 16.5996 5.58375 17.0779ZM13.8678 4.66669C16.8078 4.66669 19.1983 7.05835 19.1983 9.99719C19.1983 12.936 16.8078 15.3277 13.8678 15.3277H13.8363C12.4129 15.323 11.0794 14.7654 10.0808 13.7574C9.07978 12.7505 8.53262 11.4135 8.5384 9.99369C8.5384 7.05835 10.9289 4.66669 13.8678 4.66669ZM13.8678 6.41669C11.8938 6.41669 10.2884 8.02319 10.2884 9.99719C10.2849 10.9539 10.6513 11.8487 11.3221 12.5242C11.993 13.1997 12.8866 13.5742 13.8386 13.5777L13.8678 14.4527V13.5777C15.8418 13.5777 17.4483 11.9724 17.4483 9.99719C17.4483 8.02319 15.8418 6.41669 13.8678 6.41669ZM21.0883 5.80944C23.1393 6.1466 24.6291 7.90127 24.6291 9.98144C24.6245 12.0756 23.06 13.8723 20.9891 14.1628C20.9483 14.1686 20.9075 14.1709 20.8678 14.1709C20.4385 14.1709 20.064 13.8548 20.0021 13.4173C19.9356 12.9378 20.2681 12.4956 20.7476 12.4291C21.961 12.2588 22.8768 11.2064 22.8791 9.9791C22.8791 8.76227 22.0065 7.73327 20.8036 7.5361C20.3276 7.45794 20.0045 7.0076 20.0826 6.53044C20.162 6.05327 20.6088 5.7336 21.0883 5.80944ZM7.65295 6.53044C7.73112 7.0076 7.40795 7.45794 6.93195 7.5361C5.72912 7.73327 4.85645 8.76227 4.85645 9.98144C4.85878 11.2064 5.77462 12.2599 6.98678 12.4291C7.46628 12.4956 7.79878 12.9378 7.73228 13.4173C7.67045 13.8548 7.29595 14.1709 6.86662 14.1709C6.82695 14.1709 6.78612 14.1686 6.74528 14.1628C4.67445 13.8723 3.11112 12.0756 3.10645 9.98377C3.10645 7.90127 4.59628 6.1466 6.64728 5.80944C7.13845 5.73244 7.57362 6.0556 7.65295 6.53044Z" fill="#313131"/></svg>
                      </div>
                    </div>
                    <div className="col-md-6"></div>
                  </div>
                  <p className="text-center user-count">{frequentUserCount}</p>
                  <p className="text-center user-text">Frequent Users</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="green-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-3 ml-2 mb-4 mt-4">
                      <div className="text-center green-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M13.8678 16.8164L13.9995 16.8164L14.2942 16.8174C16.5466 16.8322 21.6938 17.0598 21.6938 20.5485C21.6938 24.0144 16.726 24.2404 14.3293 24.2552L13.4413 24.2552C11.1889 24.2403 6.04062 24.0131 6.04062 20.5287C6.04062 17.0585 11.1889 16.8321 13.4413 16.8174L13.736 16.8164C13.7818 16.8164 13.8257 16.8164 13.8678 16.8164ZM13.8678 18.5664C11.0958 18.5664 7.79062 18.907 7.79062 20.5287C7.79062 22.1137 10.8985 22.4842 13.6144 22.5052L13.8678 22.5062C16.6398 22.5062 19.9438 22.1667 19.9438 20.5485C19.9438 18.9105 16.6398 18.5664 13.8678 18.5664ZM23.147 16.3429C25.9738 16.7664 26.5677 18.0941 26.5677 19.1336C26.5677 19.7683 26.318 20.9268 24.6497 21.5626C24.547 21.6011 24.442 21.6198 24.3382 21.6198C23.9858 21.6198 23.6533 21.4051 23.5203 21.0563C23.3477 20.6048 23.5752 20.0984 24.0267 19.9269C24.8177 19.6259 24.8177 19.2934 24.8177 19.1336C24.8177 18.6226 24.1678 18.2656 22.8868 18.0743C22.4097 18.0019 22.0795 17.5574 22.1507 17.0779C22.2218 16.5996 22.6652 16.2811 23.147 16.3429ZM5.58375 17.0779C5.65492 17.5574 5.32475 18.0019 4.84758 18.0743C3.56658 18.2656 2.91675 18.6226 2.91675 19.1336C2.91675 19.2934 2.91675 19.6248 3.70892 19.9269C4.16042 20.0984 4.38792 20.6048 4.21525 21.0563C4.08225 21.4051 3.74975 21.6198 3.39741 21.6198C3.29358 21.6198 3.18858 21.6011 3.08591 21.5626C1.41641 20.9256 1.16675 19.7671 1.16675 19.1336C1.16675 18.0953 1.76058 16.7664 4.58858 16.3429C5.07042 16.2823 5.51142 16.5996 5.58375 17.0779ZM13.8678 4.66669C16.8078 4.66669 19.1983 7.05835 19.1983 9.99719C19.1983 12.936 16.8078 15.3277 13.8678 15.3277H13.8363C12.4129 15.323 11.0794 14.7654 10.0808 13.7574C9.07978 12.7505 8.53262 11.4135 8.5384 9.99369C8.5384 7.05835 10.9289 4.66669 13.8678 4.66669ZM13.8678 6.41669C11.8938 6.41669 10.2884 8.02319 10.2884 9.99719C10.2849 10.9539 10.6513 11.8487 11.3221 12.5242C11.993 13.1997 12.8866 13.5742 13.8386 13.5777L13.8678 14.4527V13.5777C15.8418 13.5777 17.4483 11.9724 17.4483 9.99719C17.4483 8.02319 15.8418 6.41669 13.8678 6.41669ZM21.0883 5.80944C23.1393 6.1466 24.6291 7.90127 24.6291 9.98144C24.6245 12.0756 23.06 13.8723 20.9891 14.1628C20.9483 14.1686 20.9075 14.1709 20.8678 14.1709C20.4385 14.1709 20.064 13.8548 20.0021 13.4173C19.9356 12.9378 20.2681 12.4956 20.7476 12.4291C21.961 12.2588 22.8768 11.2064 22.8791 9.9791C22.8791 8.76227 22.0065 7.73327 20.8036 7.5361C20.3276 7.45794 20.0045 7.0076 20.0826 6.53044C20.162 6.05327 20.6088 5.7336 21.0883 5.80944ZM7.65295 6.53044C7.73112 7.0076 7.40795 7.45794 6.93195 7.5361C5.72912 7.73327 4.85645 8.76227 4.85645 9.98144C4.85878 11.2064 5.77462 12.2599 6.98678 12.4291C7.46628 12.4956 7.79878 12.9378 7.73228 13.4173C7.67045 13.8548 7.29595 14.1709 6.86662 14.1709C6.82695 14.1709 6.78612 14.1686 6.74528 14.1628C4.67445 13.8723 3.11112 12.0756 3.10645 9.98377C3.10645 7.90127 4.59628 6.1466 6.64728 5.80944C7.13845 5.73244 7.57362 6.0556 7.65295 6.53044Z" fill="#313131"/></svg>
                      </div>
                    </div>
                    <div className="col-md-6"></div>
                  </div>
                  <p className="text-center user-count">{nonFrequentUserCount}</p>
                  <p className="text-center user-text">Not Frequent Users</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="blue-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-3 ml-2 mb-4 mt-4">
                      <div className="text-center blue-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M13.8678 16.8164L13.9995 16.8164L14.2942 16.8174C16.5466 16.8322 21.6938 17.0598 21.6938 20.5485C21.6938 24.0144 16.726 24.2404 14.3293 24.2552L13.4413 24.2552C11.1889 24.2403 6.04062 24.0131 6.04062 20.5287C6.04062 17.0585 11.1889 16.8321 13.4413 16.8174L13.736 16.8164C13.7818 16.8164 13.8257 16.8164 13.8678 16.8164ZM13.8678 18.5664C11.0958 18.5664 7.79062 18.907 7.79062 20.5287C7.79062 22.1137 10.8985 22.4842 13.6144 22.5052L13.8678 22.5062C16.6398 22.5062 19.9438 22.1667 19.9438 20.5485C19.9438 18.9105 16.6398 18.5664 13.8678 18.5664ZM23.147 16.3429C25.9738 16.7664 26.5677 18.0941 26.5677 19.1336C26.5677 19.7683 26.318 20.9268 24.6497 21.5626C24.547 21.6011 24.442 21.6198 24.3382 21.6198C23.9858 21.6198 23.6533 21.4051 23.5203 21.0563C23.3477 20.6048 23.5752 20.0984 24.0267 19.9269C24.8177 19.6259 24.8177 19.2934 24.8177 19.1336C24.8177 18.6226 24.1678 18.2656 22.8868 18.0743C22.4097 18.0019 22.0795 17.5574 22.1507 17.0779C22.2218 16.5996 22.6652 16.2811 23.147 16.3429ZM5.58375 17.0779C5.65492 17.5574 5.32475 18.0019 4.84758 18.0743C3.56658 18.2656 2.91675 18.6226 2.91675 19.1336C2.91675 19.2934 2.91675 19.6248 3.70892 19.9269C4.16042 20.0984 4.38792 20.6048 4.21525 21.0563C4.08225 21.4051 3.74975 21.6198 3.39741 21.6198C3.29358 21.6198 3.18858 21.6011 3.08591 21.5626C1.41641 20.9256 1.16675 19.7671 1.16675 19.1336C1.16675 18.0953 1.76058 16.7664 4.58858 16.3429C5.07042 16.2823 5.51142 16.5996 5.58375 17.0779ZM13.8678 4.66669C16.8078 4.66669 19.1983 7.05835 19.1983 9.99719C19.1983 12.936 16.8078 15.3277 13.8678 15.3277H13.8363C12.4129 15.323 11.0794 14.7654 10.0808 13.7574C9.07978 12.7505 8.53262 11.4135 8.5384 9.99369C8.5384 7.05835 10.9289 4.66669 13.8678 4.66669ZM13.8678 6.41669C11.8938 6.41669 10.2884 8.02319 10.2884 9.99719C10.2849 10.9539 10.6513 11.8487 11.3221 12.5242C11.993 13.1997 12.8866 13.5742 13.8386 13.5777L13.8678 14.4527V13.5777C15.8418 13.5777 17.4483 11.9724 17.4483 9.99719C17.4483 8.02319 15.8418 6.41669 13.8678 6.41669ZM21.0883 5.80944C23.1393 6.1466 24.6291 7.90127 24.6291 9.98144C24.6245 12.0756 23.06 13.8723 20.9891 14.1628C20.9483 14.1686 20.9075 14.1709 20.8678 14.1709C20.4385 14.1709 20.064 13.8548 20.0021 13.4173C19.9356 12.9378 20.2681 12.4956 20.7476 12.4291C21.961 12.2588 22.8768 11.2064 22.8791 9.9791C22.8791 8.76227 22.0065 7.73327 20.8036 7.5361C20.3276 7.45794 20.0045 7.0076 20.0826 6.53044C20.162 6.05327 20.6088 5.7336 21.0883 5.80944ZM7.65295 6.53044C7.73112 7.0076 7.40795 7.45794 6.93195 7.5361C5.72912 7.73327 4.85645 8.76227 4.85645 9.98144C4.85878 11.2064 5.77462 12.2599 6.98678 12.4291C7.46628 12.4956 7.79878 12.9378 7.73228 13.4173C7.67045 13.8548 7.29595 14.1709 6.86662 14.1709C6.82695 14.1709 6.78612 14.1686 6.74528 14.1628C4.67445 13.8723 3.11112 12.0756 3.10645 9.98377C3.10645 7.90127 4.59628 6.1466 6.64728 5.80944C7.13845 5.73244 7.57362 6.0556 7.65295 6.53044Z" fill="#313131"/></svg>
                      </div>
                    </div>
                    <div className="col-md-6"></div>
                  </div>
                  <p className="text-center user-count">{premiumUserCount}</p>
                  <p className="text-center user-text">Premium Users</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="blue-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-3 ml-2 mb-4 mt-4">
                      <div className="text-center blue-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M13.8678 16.8164L13.9995 16.8164L14.2942 16.8174C16.5466 16.8322 21.6938 17.0598 21.6938 20.5485C21.6938 24.0144 16.726 24.2404 14.3293 24.2552L13.4413 24.2552C11.1889 24.2403 6.04062 24.0131 6.04062 20.5287C6.04062 17.0585 11.1889 16.8321 13.4413 16.8174L13.736 16.8164C13.7818 16.8164 13.8257 16.8164 13.8678 16.8164ZM13.8678 18.5664C11.0958 18.5664 7.79062 18.907 7.79062 20.5287C7.79062 22.1137 10.8985 22.4842 13.6144 22.5052L13.8678 22.5062C16.6398 22.5062 19.9438 22.1667 19.9438 20.5485C19.9438 18.9105 16.6398 18.5664 13.8678 18.5664ZM23.147 16.3429C25.9738 16.7664 26.5677 18.0941 26.5677 19.1336C26.5677 19.7683 26.318 20.9268 24.6497 21.5626C24.547 21.6011 24.442 21.6198 24.3382 21.6198C23.9858 21.6198 23.6533 21.4051 23.5203 21.0563C23.3477 20.6048 23.5752 20.0984 24.0267 19.9269C24.8177 19.6259 24.8177 19.2934 24.8177 19.1336C24.8177 18.6226 24.1678 18.2656 22.8868 18.0743C22.4097 18.0019 22.0795 17.5574 22.1507 17.0779C22.2218 16.5996 22.6652 16.2811 23.147 16.3429ZM5.58375 17.0779C5.65492 17.5574 5.32475 18.0019 4.84758 18.0743C3.56658 18.2656 2.91675 18.6226 2.91675 19.1336C2.91675 19.2934 2.91675 19.6248 3.70892 19.9269C4.16042 20.0984 4.38792 20.6048 4.21525 21.0563C4.08225 21.4051 3.74975 21.6198 3.39741 21.6198C3.29358 21.6198 3.18858 21.6011 3.08591 21.5626C1.41641 20.9256 1.16675 19.7671 1.16675 19.1336C1.16675 18.0953 1.76058 16.7664 4.58858 16.3429C5.07042 16.2823 5.51142 16.5996 5.58375 17.0779ZM13.8678 4.66669C16.8078 4.66669 19.1983 7.05835 19.1983 9.99719C19.1983 12.936 16.8078 15.3277 13.8678 15.3277H13.8363C12.4129 15.323 11.0794 14.7654 10.0808 13.7574C9.07978 12.7505 8.53262 11.4135 8.5384 9.99369C8.5384 7.05835 10.9289 4.66669 13.8678 4.66669ZM13.8678 6.41669C11.8938 6.41669 10.2884 8.02319 10.2884 9.99719C10.2849 10.9539 10.6513 11.8487 11.3221 12.5242C11.993 13.1997 12.8866 13.5742 13.8386 13.5777L13.8678 14.4527V13.5777C15.8418 13.5777 17.4483 11.9724 17.4483 9.99719C17.4483 8.02319 15.8418 6.41669 13.8678 6.41669ZM21.0883 5.80944C23.1393 6.1466 24.6291 7.90127 24.6291 9.98144C24.6245 12.0756 23.06 13.8723 20.9891 14.1628C20.9483 14.1686 20.9075 14.1709 20.8678 14.1709C20.4385 14.1709 20.064 13.8548 20.0021 13.4173C19.9356 12.9378 20.2681 12.4956 20.7476 12.4291C21.961 12.2588 22.8768 11.2064 22.8791 9.9791C22.8791 8.76227 22.0065 7.73327 20.8036 7.5361C20.3276 7.45794 20.0045 7.0076 20.0826 6.53044C20.162 6.05327 20.6088 5.7336 21.0883 5.80944ZM7.65295 6.53044C7.73112 7.0076 7.40795 7.45794 6.93195 7.5361C5.72912 7.73327 4.85645 8.76227 4.85645 9.98144C4.85878 11.2064 5.77462 12.2599 6.98678 12.4291C7.46628 12.4956 7.79878 12.9378 7.73228 13.4173C7.67045 13.8548 7.29595 14.1709 6.86662 14.1709C6.82695 14.1709 6.78612 14.1686 6.74528 14.1628C4.67445 13.8723 3.11112 12.0756 3.10645 9.98377C3.10645 7.90127 4.59628 6.1466 6.64728 5.80944C7.13845 5.73244 7.57362 6.0556 7.65295 6.53044Z" fill="#313131"/></svg>
                      </div>
                    </div>
                    <div className="col-md-6"></div>
                  </div>
                  <p className="text-center user-count">{basicUserCount}</p>
                  <p className="text-center user-text">Basic Users</p>
                </div>
              </div>
            </div>
          </div>
          {/* Tabs Section */}
          <div className="row mb-3">
            <div className="col-md-12">
              <ul className="nav nav-tabs" id="userTabs" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${key === "" ? "active" : ""}`}
                    onClick={() => setKey("")}
                    type="button"
                    role="tab"
                  >
                    All Users
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${key === "new" ? "active" : ""}`}
                    onClick={() => setKey("new")}
                    type="button"
                    role="tab"
                  >
                    New Users
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${key === "frequent" ? "active" : ""}`}
                    onClick={() => setKey("frequent")}
                    type="button"
                    role="tab"
                  >
                    Frequent Users
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${key === "no-frequent" ? "active" : ""}`}
                    onClick={() => setKey("no-frequent")}
                    type="button"
                    role="tab"
                  >
                    Not Frequent Users
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${key === "premium" ? "active" : ""}`}
                    onClick={() => setKey("premium")}
                    type="button"
                    role="tab"
                  >
                    Premium Users
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${key === "basic" ? "active" : ""}`}
                    onClick={() => setKey("basic")}
                    type="button"
                    role="tab"
                  >
                    Basic Users
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-12 col-md-6">
              <label className="d-flex align-items-center">
                Show{" "}
                <select
                  className="form-control entry-select ml-2 mr-2"
                  value={entries}
                  onChange={updateEntries}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div>
            <div className="col-sm-12 ml-auto col-md-3">
              <div className="d-flex align-items-center">
                <label className="mr-3 mb-0">Search: </label>
                <input
                  className="form-control"
                  onChange={handleInputChange}
                  value={search}
                />
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
            >
              <thead className="bg-col">
                <tr>
                  <th className="border-right-0 ">
                    <input
                      type="checkbox"
                      className="form-control check-box "
                    />
                  </th>
                  <th>User Name</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {usersList.length === 0 && (
                  <p className="mt-2">No Data Available</p>
                )}
                {usersList.length > 0 &&
                  usersList.map((admin) => {
                    return (
                      <tr key={admin.id}>
                        <td className="text-center border-right-0 ">
                          <input
                            type="checkbox"
                            className="form-control check-box "
                          />
                        </td>
                        <td className="border-right-0 ">
                          <img
                            className="img-profile rounded-circle photo mr-2"
                            src={admin.pic_url ? admin.pic_url : profile}
                            alt="profile"
                          />{" "}
                          {admin?.user_name}
                        </td>
                        <td className="border-right-0 ">
                          {roleType[admin?.role]}
                        </td>

                        <td>
                          <span>
                            <FontAwesomeIcon
                              icon={faEye}
                              className="bg-success text-white p-1 rounded mr-3 cursor-pointer"
                              onClick={() => navigate(admin.user_id)}
                            />
                          </span>
                          <span onClick={() => deleteHandler(admin.user_id)}>
                            <FontAwesomeIcon
                              icon={faTrashAlt}
                              className="bg-danger text-white p-1 rounded mr-3 cursor-pointer"
                            />
                          </span>
                          <span>
                            <ToggleSwitch
                              id={admin.user_id}
                              toggleSwitchHandler={toggleSwitchHandler}
                            />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          {pageData.totalPages > 1 && (
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageData.totalPages}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-end"
              activeClassName="active"
              previousLabel="<"
              forcePage={pageData.currentPage - 1}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Users;
